import { Businesses } from "../config/Helper";

const SERVER_URL = "";

export const API_URL = window.api_url;
// export const API_URL = `http://localhost:4001/api/v1`

export const desktop = (business, id, file_name) => {
    return `${SERVER_URL}/uploads/${Businesses[business]}/${id}/${file_name}`;
};
// export const link = (business, id, file_name) => {
//     const blogList = ['news', 'event', 'experience', 'activity', 'agency_news', 'folkways', 'article']
//     const check = blogList.filter(item => { return item === Businesses[business] })
//     if (check.length)
//         return `${SERVER_URL}/blog/${Businesses[business]}/${id}`;
//     else return `${SERVER_URL}/${Businesses[business]}/${id}`;
// }

export const link = (business, id, file_name) => {
    const blogList = [
        "news",
        "event",
        "experience",
        "activity",
        "agency_news",
        "folkways",
        "article",
    ];
    const check = blogList.filter((item) => {
        return item === Businesses[business];
    });
    if (check.length) return `blog/${Businesses[business]}/${id}`;
    else return `${Businesses[business]}/${id}`;
};

export const tablet = (business, id, file_name) => {
    return `${SERVER_URL}/uploads/${Businesses[business]}/${id}/tablet/${file_name}`;
};

export const mobile = (business, id, file_name) => {
    return `${SERVER_URL}/uploads/${Businesses[business]}/${id}/mobile/${file_name}`;
};

export const thumbnail = (business, id, file_name) => {
    return `${SERVER_URL}/uploads/${Businesses[business]}/${id}/thumbnail/${file_name}`;
};

export const bannerURL = (file_name) => {
    return `${SERVER_URL}/uploads/banner/${file_name}`;
};

export const homeAdsURL = (file_name) => {
    return `${SERVER_URL}/uploads/home_banner/${file_name}`;
};

export const agencyMarkURL = (file_name) => {
    return `${SERVER_URL}/uploads/agency_mark/${file_name}`;
};

export const orgMarkURL = (file_name) => {
    return `${SERVER_URL}/uploads/mark/${file_name}`;
};
